//src/useNurseData.js use to fetch booking Data after added to database and send to dashboard

import { reactive, ref, onMounted, toRefs } from "vue";
import { db } from "@/firebaseConfig";
import { collection, getDocs, query, where } from "firebase/firestore"; // Import query and where

const nurseStore = reactive({
  nurseItems: [],
  isLoading: false,
  error: null,
});

const fetchNurseData = async () => {
  nurseStore.isLoading = true;
  nurseStore.error = null;
  try {
    const nurseCollectionRef = collection(db, "booking");
    const q = query(nurseCollectionRef, where("bookStatus", "!=", "cancel")); // Use != to exclude 'cancel'
    const querySnapshot = await getDocs(q);
    const data = [];

    querySnapshot.forEach((doc) => {
      const docData = doc.data();


      // Parse dates directly from document fields
      let startDateTime =
        typeof docData.startDate === "string"
          ? new Date(docData.startDate)
          : docData.startDate?.toDate?.();

      let endDateTime =
        typeof docData.endDate === "string"
          ? new Date(docData.endDate)
          : docData.endDate?.toDate?.();

      if (
        !startDateTime ||
        !endDateTime ||
        isNaN(startDateTime.getTime()) ||
        isNaN(endDateTime.getTime())
      ) {
        return;
      }

      const status = (docData.status ?? "unknown").toLowerCase();
      const roomIdentifier = docData.room || docData.roomName || "N/A Room";

      // DO NOT use ...docData — it spreads raw Firestore Timestamp objects
      // (createAt, startDate, endDate) into Vue reactive state.
      // Chrome's strict String() coercion in Vue's warn formatter crashes on them.
      // Pick ONLY the fields we need, all as safe JS primitives.
      data.push({
        id: doc.id,
        start: startDateTime,                    // JS Date
        end: endDateTime,                        // JS Date
        status: status,                          // lowercased string
        room: roomIdentifier,                    // string
        bookBy: String(docData.bookBy || ""),
        bId: String(docData.bId || ""),
        bStatus: String(docData.bookStatus || ""),
        note: String(docData.note || ""),
        sNote: String(docData.sNote || ""),
        advisor: String(docData.advisor || ""),
        tel: String(docData.tel || ""),
        number: Number(docData.number) || 0,
        allday: Boolean(docData.allday),
        purpose: Array.isArray(docData.purpose) ? docData.purpose.map(String) : [],
        // createAt is intentionally excluded — it's a Firestore Timestamp
      });
    });

    nurseStore.nurseItems = data;
  } catch (err) {
    console.error("Error fetching nurse data:", err);
    nurseStore.error = err;
  } finally {
    nurseStore.isLoading = false;
  }
};

export function useNurseData() {
  onMounted(() => {
    fetchNurseData();
  });

  return {
    ...toRefs(nurseStore),
    fetchNurseData,
  };
}
